(function () {
  document.querySelectorAll('[data-sova-countdown]').forEach(function (root) {
    var raw = (root.getAttribute('data-end') || '').trim();
    if (!raw) return;

    var normalised = raw.replace(' ', 'T');
    var end = new Date(normalised);
    if (isNaN(end.getTime())) {
      end = new Date(raw);
      if (isNaN(end.getTime())) return;
    }

    var behaviour = root.getAttribute('data-expired-behaviour') || 'hide';
    var clock = root.querySelector('[data-sova-countdown-clock]');
    var expiredEl = root.querySelector('[data-sova-countdown-expired]');
    var label = root.querySelector('.sova-countdown-label');

    var dEl = root.querySelector('[data-cd-days]');
    var hEl = root.querySelector('[data-cd-hours]');
    var mEl = root.querySelector('[data-cd-mins]');
    var sEl = root.querySelector('[data-cd-secs]');

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    function expire() {
      if (behaviour === 'message' && expiredEl) {
        root.hidden = false;
        if (clock) clock.hidden = true;
        if (label) label.hidden = true;
        expiredEl.hidden = false;
      } else {
        root.hidden = true;
      }
    }

    function tick() {
      var diff = end.getTime() - Date.now();

      if (diff <= 0) {
        expire();
        clearInterval(timer);
        return;
      }

      root.hidden = false;

      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400);
      var hours = Math.floor((secs % 86400) / 3600);
      var mins = Math.floor((secs % 3600) / 60);
      var rem = secs % 60;

      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(rem);
    }

    tick();
    var timer = setInterval(tick, 1000);
  });
})();
